module.exports = __webpack_public_path__ + "media/images/hitfun/icon.tag.black-366eea69bd865f89ad831eaf14019728.svg";